import React from 'react';
import './TicketList.css';

import TicketCard from '../TicketCard/TicketCard';
import NewPrizeCard from '../redesign/NewTicketCard'
import PostalEntry from '../PostalEntry/PostalEntry';
import SubscriptionEntry from '../SubscriptionEntry/SubscriptionEntry';
import ReactHtmlParse from 'html-react-parser';
import useTickets from '../../hooks/useTickets';
import {TitleText, SubtitleText} from "raffle-house-uikit";

const TicketList = (props) => {
  const {
    prizeId,
    raffles,
    isExpired,
    currentRaffle,
    title,
    subtitle,
    theme = 'light',
    reference,
    bonusDraw
  } = props;
  const {
    type,
    loading,
    activeTicket,
    addToBasket,
    result,
    ticketsBundles,
  } = useTickets({prizeId, isDouble: raffles.length > 1});

  return (
    <div className='ticket-container' ref={reference}>
      <div className='ticket-text-container'>
        {Boolean(title) && (
          <TitleText
            isCentered
            as='h2'
            variant={'primary'}
            color={`${theme === 'light' ? 'color-1' : 'color-5'}`}
          >
            {ReactHtmlParse(title)}
          </TitleText>
        )}
        {Boolean(subtitle) && (
          <SubtitleText
            isCentered
            color={`${theme === 'light' ? 'color-1' : 'color-5'}`}
          >
            {ReactHtmlParse(subtitle)}
          </SubtitleText>
        )}
      </div>
      <div className='ticket-list'>
        <>
          {prizeId &&
            ticketsBundles?.map((ticket, index) => {
              let label = '';
              if (ticket === 15) {
                label = 'MOST POPULAR';
              }
              if (ticket === 25) {
                label = 'LOWEST TICKET PRICE';
              }
              return (
                <NewPrizeCard
                  type={type}
                  key={index}
                  activeTicket={activeTicket}
                  ticket={ticket}
                  ticketsCount={ticket}
                  loading={loading}
                  onClick={addToBasket}
                  raffles={raffles}
                  isExpired={isExpired}
                  currentRaffle={currentRaffle}
                  theme={theme}
                  label={label}
                  result={result}
                  bonusDraw={bonusDraw}
                />
              );
            })}
          <PostalEntry loading={loading} theme={raffles.length > 1 ? 'light' : theme} />
        </>
      </div>
    </div>
  );
};

export default TicketList;
